if(!__webpack_require__.federation){
	__webpack_require__.federation = {
		initOptions: {"name":"Host","remotes":[],"shareStrategy":"version-first"},
		chunkMatcher: function(chunkId) {return !/^(13|228|298|335|394|527|619|643)$/.test(chunkId)},
		rootOutputDir: "",
		initialConsumes: undefined,
		bundlerRuntimeOptions: {}
	};
}